import React from "react";
import PageSeo from "components/Seo/PageSeo";
import { useSelector } from "react-redux";
import BannerTitle from "components/BannerTitle/bannertitle";
import "./jobApplication.css";
import Button from "@mui/material/Button";

const JobApplication = () => {
  const jobApplication = useSelector((state) => state.contentfulReducer.job);

  const renderRichText = (richTextDocument) => {
    return richTextDocument.content.map((node, index) => {
      switch (node.nodeType) {
        case "paragraph":
          return <p key={index}>{node.content[0].value}</p>;
        case "unordered-list":
          return (
            <ul key={index}>
              {node.content.map((listItem, listItemIndex) => (
                <li key={listItemIndex}>
                  {listItem.content[0].content[0].value}
                </li>
              ))}
            </ul>
          );
        case "ordered-list":
          return (
            <ol key={index}>
              {node.content.map((listItem, listItemIndex) => (
                <li key={listItemIndex}>
                  {listItem.content[0].content[0].value}
                </li>
              ))}
            </ol>
          );
        default:
          return null;
      }
    });
  };

  return (
    <div className="job-application-page">
      <PageSeo
        title="Job Application"
        description="Apply for a coaching or staff position at Ace Gymnastics in Bardstown, Kentucky."
        path="/job-application"
      />
      <BannerTitle title="Employment Application" />
      <div className="job-details">
        <h2 className="job-details__title">{jobApplication.jobTitle}</h2>
        <p>
          <strong>Location:</strong> {jobApplication.location}
        </p>
        <h2>Description</h2>
        <p>{jobApplication.description}</p>
        <h2>Responsibilities</h2>
        {renderRichText(jobApplication.responsibilities)}
        <h2>Qualifications</h2>
        {renderRichText(jobApplication.qualifications)}
        <h2>Working Hours</h2>
        {renderRichText(jobApplication.workingHours)}
        <h2>Compensation</h2>
        {renderRichText(jobApplication.compensation)}
        <div className="button-container">
          <Button
            variant="contained"
            href="https://docs.google.com/forms/d/e/1FAIpQLScEsZWrretOPpwmS9sLAyA_6slt4f6v9Gc1C4DemjRaR0Q7-A/viewform"
            target="_blank"
            rel="noopener noreferrer"
            data-track="job_apply_click"
            data-track-location="job_application_page"
          >
            Apply
          </Button>
        </div>
      </div>
    </div>
  );
};

export default JobApplication;
